import React from 'react';
import PropTypes from 'prop-types';
import WButton from '../WButton/WButton';
import WModal from '../WModal/WModal';
import styles from '../CommonStyles';

const assignObj = (obj) => { return obj; };

const WSubmitModal= (props) => {
    const {show} = props;
    const saveMsg = 'Your application has been submitted';
    const handleHide = () =>props.modalClick('hide');
    const handleExit = () => props.modalClick('exit');
    if(show) {
        return (
            <WModal 
            style={styles.popupModalStyle}
            closebutton=""
            header="Submitted" 
            modalheaderstyle={styles.popupModalHeaderStyle}     
            modalfooterstyle={styles.popupModalFooterStyle}                     
            headertextstyle={styles.popupModalHeaderTextStyle}
            modalbodystyle={styles.popupModalBodyStyle}            
            size="lg" 
            dialogClassName="myModal" 
            show={show} 
            onHide={handleHide} 
            body=
            {
               <div style={styles.popupModalDivStyle}>
               <div style={styles.popupModalBodyTextStyle}>{saveMsg}</div>
               <div style={styles.popupModalBodyTextStyle}>{props.msg} </div>
               </div>
            } 
            footer={
                <div style={assignObj({marginTop:10})}>
                    <WButton buttontext="EXIT" buttonstyle={styles.popupModalButtonStyle} buttontextstyle={styles.popupModalButtonTextStyle} onClick={handleExit}/>
                </div>
            }                           
        />
        );
    } 
        return null;
    
} 

WSubmitModal.propTypes={
    modalClick: PropTypes.func,
    show:PropTypes.bool,
    msg:PropTypes.string
}

WSubmitModal.defaultProps={     
    modalClick: () => {},
    show: false,
    msg:''
}

export default WSubmitModal;



